import React, { Suspense, useContext, useEffect, useState } from "react";
import { OperationContext } from "../CreateOperation";
import { TitleBadge } from "../components/TitleBadge";
import { Empty, Radio } from "antd";
import { CustomTabs } from "../../../../../common/components/Tabs/CustomTabs";
import { capitalizeFirstLetter } from "../../../../../utilities/string";
import { Loader } from "../../../../../common/components/Loader/Loader";
import { OperationConstant } from "../../../core/_constant";
import { useSearchParams } from "react-router";

export const ExecutionReport = () => {

  const { initialValue } = useContext(OperationContext);
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabItems, setTabItems] = useState<Array<any>>([]);

  const EXECUTION_REPORT_ALL_TYPE = [
    initialValue?.debarkationMovement?.id
      ? {
          label: OperationConstant.LANDING_LABEL,
          value: initialValue.debarkationMovement.id,
        }
      : null,
  
    initialValue?.embarkationMovement?.id
      ? {
          label: OperationConstant.BOARDING_LABEL,
          value: initialValue.embarkationMovement.id,
        }
      : null,
  ].filter(
    (item): item is { label: string; value: number | string } => item !== null
  );

  const [selectedMovementId, setSelectedMovementId] = useState(
    EXECUTION_REPORT_ALL_TYPE[0]?.value
  );

  useEffect(() => {
    if (
      !selectedMovementId &&
      EXECUTION_REPORT_ALL_TYPE.length
    ) {
      setSelectedMovementId(EXECUTION_REPORT_ALL_TYPE[0].value);
    }
  }, [initialValue]);

  const selectedMovement =
  initialValue?.debarkationMovement?.id === selectedMovementId
    ? initialValue?.debarkationMovement
    : initialValue?.embarkationMovement;

  const handleMovementChange = (movementId: number) => {
    setSelectedMovementId(movementId);
  
    const movement =
      initialValue?.debarkationMovement?.id === movementId
        ? initialValue?.debarkationMovement
        : initialValue?.embarkationMovement;
  
    const firstTab = movement?.loadPossessionStatus?.[0];
  
    if (firstTab) {
      const newParams = new URLSearchParams(searchParams);
  
      newParams.set("mouvement", firstTab.id.toLowerCase());
  
      setSearchParams(newParams);
    }
  };

  useEffect(() => {
    setTabItems(
      selectedMovement?.loadPossessionStatus?.map(
        (item: any) => {
          const Component = DynamicComponent(capitalizeFirstLetter(item?.id));
          return {
            ...item,
            key: item?.id,
            label: item?.name,
            children: (
              <Suspense fallback={<Loader isLoading />}>
                {Component && <Component currentMovement={selectedMovement}/>}
              </Suspense>
            ),
          };
        }
      )
    );
  }, [initialValue, selectedMovementId]);

  const DynamicComponent = (name: string) => {
    try {
      return React.lazy(() => import(`./${name}List.tsx`));
    } catch (error) {
      console.error("Error loading component", error);
      return null;
    }
  };

  return (
    <>
    {
      tabItems ? (
      <div>
        <div className="d-flex flex-wrap gap-2 mb-4">
          <TitleBadge
            label="Référence du voyage"
            value={initialValue?.travelReference}
          />
          <TitleBadge
            label="Opération"
            value={initialValue?.operationType?.label}
          />
          <TitleBadge label="Client" value={initialValue?.customer?.label} />
        </div>
        
        <div className="">
          <Radio.Group
            options={EXECUTION_REPORT_ALL_TYPE}
            value={selectedMovementId}
            onChange={(e) => handleMovementChange(e.target.value)}
            optionType="button"
            buttonStyle="solid"
          />

          {tabItems?.length && (
            <CustomTabs items={tabItems} tabName="mouvement" isSetDefaultActive/>
          )}
        </div>
      </div>
      ) : (
        <Empty description="En attente de manifeste"/>
      )
    }
    </>
  );
};
